module.exports = __webpack_public_path__ + "images/emoji/mahjong.0c64467cf20d272ca3e1.png";